import startCase from "lodash/startCase";
import { getConfig } from "utils/env";
const HOME = "home";
const ANALYTICS = "analytics";
const PAGES = "pages";
const LINKS = "links";
const FILES = "files";
const CAMPAIGNS = "campaigns";
const PRODUCTS = "products";
const COUPONS = "coupons";
const SETTINGS = "settings";
const SALES = "sales";
const TAX_RATES = "taxRates";
// const FEATURES = "features";

export const HUB_APP_SUB_SECTION = {
  HOME,
  ANALYTICS,
  PAGES,
  LINKS,
  PRODUCTS,
  COUPONS,
  SETTINGS,
  SALES,
  TAX_RATES,
  FILES,
  CAMPAIGNS
  // FEATURES
};

const HOME_CONFIG = {
  id: HOME,
  label: startCase(HOME),
  icon: HOME
};

const ANALYTICS_CONFIG = {
  id: ANALYTICS,
  label: startCase(ANALYTICS),
  icon: ANALYTICS
};

const PAGES_CONFIG = {
  id: PAGES,
  label: startCase(PAGES),
  icon: PAGES
};

const LINKS_CONFIG = {
  id: LINKS,
  label: "Payment links",
  icon: LINKS
};

const FILES_CONFIG = {
  id: FILES,
  label: startCase(FILES),
  icon: FILES
};

const CAMPAIGNS_CONFIG = {
  id: CAMPAIGNS,
  label: startCase(CAMPAIGNS),
  icon: CAMPAIGNS
};

const PRODUCTS_CONFIG = {
  id: PRODUCTS,
  label: startCase(PRODUCTS),
  icon: PRODUCTS
};

const COUPONS_CONFIG = {
  id: COUPONS,
  label: startCase(COUPONS),
  icon: COUPONS
};

const TAX_RATES_CONFIG = {
  id: TAX_RATES,
  label: startCase(TAX_RATES),
  icon: TAX_RATES
};

const SETTINGS_CONFIG = {
  id: SETTINGS,
  label: startCase(SETTINGS),
  icon: SETTINGS
};

const SALES_CONFIG = {
  id: SALES,
  label: startCase(SALES),
  icon: SALES
};

// const FEATURES_CONFIG = {
//   id: FEATURES,
//   label: startCase(FEATURES),
//   icon: FEATURES
// };

export const HUB_APP_SUB_SECTION_CONFIG = [
  HOME_CONFIG,
  SALES_CONFIG,
  PAGES_CONFIG,
  PRODUCTS_CONFIG,
  COUPONS_CONFIG,
  LINKS_CONFIG,
  TAX_RATES_CONFIG,
  ANALYTICS_CONFIG,
  SETTINGS_CONFIG,
  FILES_CONFIG
  // FEATURES_CONFIG
];

const LINKS_SUBDOMAINS = [
  getConfig("APP_SUBDOMAIN"),
  "getdevplan",
  // "lanternboard",
  "dataships",
  // N.N
  "dawn-cloud-5741",
  // K.G
  "holy-water-4851",
  // P.Y
  "hidden-river-8149",
  // S.I
  "softwareideas",
  // J.J
  "transistor",
  "sematext",
  "raysquiggles",
  "rgi",
  "globalsisterhood"
];

const USER_ROOTS = [
  "shanerogers126",
  "rayquig",
  "peter.g.yang",
  "nickjnish",
  "raj.tut",
  "timetoinjoy"
];

export const enableBetaSectionsForApp = ({ subdomain, email }) => {
  return (
    (subdomain && LINKS_SUBDOMAINS.indexOf(subdomain) > -1) ||
    (email && USER_ROOTS.indexOf(email.split("@")[0]) > -1)
  );
};

/**
 * Configure sidebar Hub nav sub sections
 */
export const getOrderedAppSubSections = ({ subdomain, email }) => {
  const result = [
    HOME_CONFIG,
    SALES_CONFIG,
    LINKS_CONFIG,
    PRODUCTS_CONFIG,
    COUPONS_CONFIG,
    TAX_RATES_CONFIG,
    FILES_CONFIG
    // FEATURES_CONFIG
  ];
  const betaEnabled = enableBetaSectionsForApp({ subdomain, email });

  if (betaEnabled) {
    /**
     * Push additional beta sections here
     */
    result.push(CAMPAIGNS_CONFIG);
    result.push(PAGES_CONFIG);
    result.push(ANALYTICS_CONFIG);
  }
  result.push(SETTINGS_CONFIG);

  return result;
};
